module.exports = __webpack_public_path__ + "static/media/12.549f5d80.JPG";